import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import "../../styles/community.scss"

const Herosection = ({ title }) => {
  return (
    <section id="FAQ-hero-section">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <h1>{title}</h1>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Herosection
